const KEY = "rc_recent_products";
const MAX = 12;

export function pushRecentlyViewed(item) {
  if (!item || !item.id) return;
  try {
    const list = getRecentlyViewed().filter((x) => x.id !== item.id);
    list.unshift({ id: item.id, title: item.title, image: item.image, price: item.price, currency: item.currency });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {}
}

export function getRecentlyViewed() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
